import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrormessageComponent } from './errormessage.component';



@NgModule({
    imports: [
        CommonModule,
        ErrormessageComponent
    ],
    exports: [ErrormessageComponent]
})
export class ErrormessageModule { }
